import LoadingScreen from '../components/loading/LoadingScreen';

const ProtectedRoute = ({ children, authState }) => {
  console.log('ProtectedRoute - AuthState:', authState);
  console.log('ProtectedRoute - URL:', window.location.pathname);

  // Still loading auth state
  if (!authState) {
    console.log('ProtectedRoute: Auth state loading...');
    return <LoadingScreen message="Checking authentication..." />;
  }

  // User is authenticated
  if (authState.isAuthenticated) {
    console.log('ProtectedRoute: User authenticated, showing children');
    return children;
  }

  return <LoadingScreen message="Redirecting to login..." />;
};

export default ProtectedRoute;
